<template>
  <!--    <template v-slot:activator="{ on, attrs }">-->
  <!--      <v-card-subtitle class="pt-2 pt-md-4">-->
  <!--        <v-btn outlined color="primary" v-bind="attrs" v-on="on">-->
  <!--          {{ $t('cap_new_menu')}}-->
  <!--        </v-btn>-->
  <!--      </v-card-subtitle>-->
  <!--    </template>-->
  <v-card>
    <v-card-text>
      <v-card-title class="text-h6 primary--text">
        {{ $t('cap_new_menu') }}
      </v-card-title>
      <v-card-subtitle class="pt-2 pt-md-4">
        <span>
          {{ $t('title_category_menu_info') }}
        </span>
      </v-card-subtitle>
      <v-form ref="payCreate">
        <v-row justify="center" align="center">
          <v-col cols="12">
            <v-row>
              <v-col cols="12" md="12" class="p-0">
                <v-form ref="nameAdd">
                  <div>
                    <div>
                      <span v-if="nameForm.error" class="caption error--text">{{
                        $t('cap_msg_en_required')
                      }}</span>
                    </div>
                    <div v-for="(value, key) in nameMulti" :key="key">
                      <v-row class="pt-0 align-center" no-gutters>
                        <v-col cols="2">
                          <v-avatar
                            size="25"
                            class="white--text"
                            color="primary"
                          >
                            {{ key }}
                          </v-avatar>
                        </v-col>
                        <v-col cols="8">
                          <span class="pl-2">
                            {{ value }}
                          </span>
                        </v-col>
                        <v-col cols="2" class="justify-start align-start">
                          <v-btn text @click="onNameDeletePay(key)">
                            <v-icon color="primary">mdi-close-circle</v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </div>
                    <div>
                      <v-row>
                        <v-col cols="4">
                          <v-select
                            v-model="nameForm.lang"
                            :items="$store.state.tenant.lang"
                            solo
                            dense
                          ></v-select>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field
                            v-model="nameForm.name"
                            persistent-hint
                            outlined
                            single-line
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col cols="2">
                          <v-btn
                            class="text-capitalize primary--text text-left"
                            block
                            text
                            @click="onNameAddPay"
                          >
                            {{ $t('btn_cap_add_pricing') }}
                          </v-btn>
                        </v-col>
                      </v-row>
                    </div>
                  </div>
                </v-form>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <!--      <v-btn text class="primary&#45;&#45;text" @click="onCancel">-->
      <!--        {{ $t('btn_txt_cancel') }}-->
      <!--      </v-btn>-->
      <v-spacer></v-spacer>
      <v-btn color="primary" class="white--text" @click="onSubmit">
        {{ $t('btn_cap_save') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    locale: {
      type: String,
      default: 'en'
    }
  },
  data() {
    return {
      dialogPay: false,
      form: {
        name: {}
      },
      nameMulti: {},
      nameForm: {
        lang: 'en',
        name: '',
        error: null
      },
      error: null,
      rules: {
        required: [
          (v) =>
            Array.isArray(v)
              ? !!v && v.length > 0
              : !!v || this.$t('cap_msg_required')
        ]
      }
    }
  },
  methods: {
    // clickMenu() {
    //   this.nameMulti = this.menu
    //   if (!(this.nameMulti)) {
    //     this.nameMulti = {}
    //     this.menu = this.nameMulti
    //   }
    // },
    onNameAddPay() {
      this.nameForm.name = this.nameForm.name.trim()
      if (this.$refs.nameAdd.validate() && this.nameForm.name) {
        this.nameMulti[this.nameForm.lang] = this.nameForm.name
        this.nameForm = {
          lang: 'en',
          name: '',
          error: null
        }
      }
    },
    onNameDeletePay(key) {
      if (key in this.nameMulti) {
        this.$delete(this.nameMulti, key)
      }
    },
    onCancel() {
      this.dialogPay = false
      this.nameForm = {
        lang: 'en',
        name: '',
        error: null
      }
      this.mssForm = {
        lang: 'en',
        message: '',
        error: null
      }
      // this.nameForm = this.paymentMethod.name
      // this.mssForm = this.paymentMethod.message
      this.$refs.nameAdd.resetValidation()
      this.$refs.payCreate.resetValidation()
    },
    onSubmit() {
      if (!('en' in this.nameMulti)) {
        this.nameForm.error = true
      } else if ('en' in this.nameMulti) {
        this.nameForm.error = false
        this.dialogPay = false
        this.form.name = this.nameMulti
        // this.paymentMethods.push(this.paymentMethod)
        const createMenu = this.$store.state.tenant.menus
        createMenu.push(this.nameMulti)
        this.$store
          .dispatch('tenant/createMenu', createMenu)
          .then(() => {})
          .catch((error) => {
            this.error = error
          })
        return (this.nameMulti = {})
      }
    }
  }
}
</script>
